module.exports = __webpack_public_path__ + "static/media/Understanding_alt.75f10101.jpeg";